/**
 * Created For: 用户登录、用户信息相关接口
 * Author: chenLiYan.
 * Date: 2018/11/28 0028 15:15.
 */
import request from '@/utils/request'
// 用户登录
export function login (params) {
  return request({
    url: '/v1/account/login/username',
    method: 'post',
    data: params
  })
}

// 根据token获取用户信息
export function getUserInfo () {
  return request({
    url: '/v1/user/me/info',
    method: 'get'
  })
}
// 根据token获取用户信息
export function getUserNewInfo () {
  return request({
    url: '/v1/user/getPersonalDetailInfo',
    method: 'get'
  })
}

// 获取权限列表
export function permissionList () {
  return request({
    url: '/v1/permission/getPhonePermissionByUserUuid',
    method: 'get'
  })
}

// 获取首页信息
export function indexConfig (data) {
  return request({
    url: '/v1/other-config/values',
    method: 'post',
    data
  })
}

// 刷新token
// eslint-disable-next-line camelcase
export function refreshToken (refresh_token) {
  return request({
    // eslint-disable-next-line camelcase
    url: '/v1/account/login/refresh/' + refresh_token,
    method: 'get'
  })
}

// 获取手机验证码
export function asyncSmsCode (mobile, category = 'activate_user') {
  // category 验证码类型: activate_user,reset_password,login
  return request({
    url: '/v1/account/send_sms',
    data: {
      mobile: mobile,
      category: category
    },
    method: 'post'
  })
}

// 重置密码
export function asyncResetPwd (params) {
  // params: mobile,smsCode,newPassword
  return request({
    url: '/v1/account/password/reset',
    data: params,
    method: 'post'
  })
}

// 获取地区权限
export function getAreaTree () {
  return request({
    url: '/v1/look-permission/areatree',
    data: {
      areaCode: 'D100000',
      deptIds: null,
      personUuids: null
    },
    method: 'post'
  })
}

// 用户首次登录激活
export function asyncActivateUser (params) {
  // params: mobile,smsCode,newPassword
  return request({
    url: '/v1/account/user/activate',
    data: params,
    method: 'post'
  })
}

// 修改密码
export function asyncUpdatePwd (params) {
  // params: oldPassword,newPassword
  return request({
    url: '/v1/account/password/modify',
    data: params,
    method: 'post'
  })
}

// 退出登录
export function asyncLoginOut () {
  return request({
    url: '/v1/account/login/logout',
    method: 'post'
  })
}

/**
 * 用户操作日志 记录收集
 * @params params:{ menu:"菜单/栏目", page:"页面标题", operation:"操作动作", device:"设备", os:"操作系统",browser:"浏览器" }
 */
export function logUserAction (params) {
  return request({
    url: '/v1/user/log/operation/detail',
    method: 'get',
    params
  })
}

export function getCodeImg () {
  return request({
    url: '/v1/account/captchaImage',
    method: 'get'
  })
}
